import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiSelectModule } from 'primeng/multiselect';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SIBASI_SYSTEM_APP_MODULES } from '../model/sibasi-system.model';

@Component({
  selector: 'app-subscription-modules',
  standalone: true,
  imports: [CommonModule, MultiSelectModule, ReactiveFormsModule, FormlyModule],
  template: `
    <p>Subscription Modules *</p>
    <p-multiSelect
      [options]="subscriptionsModules"
      [formControl]="$any(formControl)"
      [formlyAttributes]="field"
      optionLabel="label"
      optionValue="value"
      defaultLabel="Select Subscription Modules"
    ></p-multiSelect>
  `,
  styles: []
})
export class SubscriptionModulesFormlyField extends FieldType {
  subscriptionsModules: { label: string; value: string }[] = Object.keys(
    SIBASI_SYSTEM_APP_MODULES
  ).map((key) => ({
    label: SIBASI_SYSTEM_APP_MODULES[key as keyof typeof SIBASI_SYSTEM_APP_MODULES],
    value: key
  }));
}
